module.exports = __webpack_public_path__ + "img/7类1级.70dd2057.png";